import styles from './active-user-details.module.scss';
import { CheckboxLabel, MenuItem, Select, TextField } from '@frontend-workspace/react-shared-lib';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { Col, Row } from 'reactstrap';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DetailsProps {
  loan?: ILoan,
  seatNumber?: number,
}

export function Details(props: DetailsProps) {
  const { t } = useTranslation();
  const isActive = (p: any) => !p.hasTerminated && p.stopTime === null;
  const activeProcesses = props.loan?.processInfo?.filter(isActive);
  const [selectedProcessInfoId, setSelectedProcessInfoId] = useState(activeProcesses != null && activeProcesses.length > 0 ? activeProcesses[0].id : null);

  const selectedProcessInfo = props.loan?.processInfo?.find(p => p.id === selectedProcessInfoId);
  const handleSelectProcessInfo = (event: any) => setSelectedProcessInfoId(event.target.value);

  return (<>
    <div className="d-inline-flex">
      <Select
        label={`${t("standard.processes")} (${props.loan?.processInfo.filter(isActive).length}/${props.loan?.processInfo.length})`}
        value={selectedProcessInfoId}
        onChange={handleSelectProcessInfo}
        className='mb-3'>
        {props.loan?.processInfo?.map((c) => <MenuItem value={c.id} key={c.id}>{`${c.processId} ${isActive(c) ? "" : t("standard.terminated")}`}</MenuItem>)}
      </Select>
    </div>
    <Row>
      <Col md={4} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={selectedProcessInfo?.mainModuleName || ''}
            fullWidth
            label={t("standard.mainProduct")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.productLicense?.idParent || props.loan?.productLicenseId || ''}
            fullWidth
            label={t("standard.mainLicenseNo")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={4} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.productLicense?.productVersion?.number || ''}
            fullWidth
            label={t("standard.productVersion")}
            disabled
            className='mb-3'
          />
          <TextField
            value={selectedProcessInfo?.mainModuleVersion || ''}
            fullWidth
            label={t("standard.fileVersion")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={4} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.seatNumber || ''}
            fullWidth
            label={t("standard.seat")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.productLicense?.maxSeats || ''}
            fullWidth
            label={t("standard.maxSeat")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={4} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <CheckboxLabel
            label={t("standard.academic")}
            checked={props.loan?.isAcademic}
            disabled={true}
          />
          <CheckboxLabel
            label='SLM'
            checked={props.loan?.productLicense?.isSlm}
            disabled={true}
          />
        </div>
      </Col>
    </Row>
  </>);
}

export default Details;